import React, { Fragment } from "react";
import { Card, CardBody, CardHeader, Col, Row } from "reactstrap";
import { H3, H5, H6 } from "../../../AbstractElements";
import CountUp from 'react-countup';
import HeaderCard from "../../Common/Component/HeaderCard";
import { CancelledSvg, DeliveredSvg, NewOrderSvg, PendingSvg, SVG20, SVG50, SVG68, SVG98 } from "../../../Data/Widgets/General/Data";
import { Complaint, InProgress, Resolved, Unresolved } from "../../../Constant";
import { Link } from "react-router-dom";

const ComplaintDetails = (props) => {
    const value = props.data;
    const OrderDetailsData = [
        {
            id: 1,
            iconClass: 'bg-light-primary',
            svg1: <NewOrderSvg />,
            title: <Link className="dashboardTableLinks" to={`${process.env.PUBLIC_URL}/service-request`}>
                {Complaint}
            </Link>,
            // title: Complaint,
            count: value.total,
            fontClass: 'font-primary',
            // icon: 'icofont-arrow-up',
            // percent: '68%',
            svg2: <SVG68 />
        },
        {
            id: 2,
            iconClass: 'bg-light-warning',
            svg1: <PendingSvg />,
            title: <Link className="dashboardTableLinks" to={`${process.env.PUBLIC_URL}/service-request?status=closed`}>
                {Resolved}
            </Link>,
            // title: Resolved,
            fontClass: 'font-warning',
            count: value.resolved,
            // icon: 'icofont-arrow-down',
            // percent: '12%',
            svg2: <SVG98 />
        },
        {
            id: 3,
            iconClass: 'bg-light-success',
            svg1: <DeliveredSvg />,
            title: <Link className="dashboardTableLinks" to={`${process.env.PUBLIC_URL}/service-request?status=in_progress`}>
                {InProgress}
            </Link>,
            // title: InProgress,
            fontClass: 'font-success',
            count: value.in_process,
            // icon: 'icofont-arrow-up',
            // percent: '50%',
            svg2: <SVG50 />
        },
        {
            id: 4,
            iconClass: 'bg-light-danger',
            svg1: <CancelledSvg />,
            title: <Link className="dashboardTableLinks" to={`${process.env.PUBLIC_URL}/service-request?status=open`}>
                {Unresolved}
            </Link>,
            // title: Unresolved,
            fontClass: 'font-danger',
            count: value.un_resolved,
            // icon: 'icofont-arrow-up',
            // percent: '20%',
            svg2: <SVG20 />
        },
    ]

    return (
        <Fragment>
            <Col xl="6" className="box-col-6">
                <Card className="widget-joins complainHeight">
                    {/* <HeaderCard title={'Service Request Details'} setting={true} /> */}
                    <CardHeader className="pb-0">
                        <H3> {'Service Request Details'} </H3>
                    </CardHeader>
                    <CardBody>
                        <Row className="gy-4">
                            {OrderDetailsData.map((data) => {
                                return (
                                    <Col sm="6" key={data.id}>
                                        <div className="widget-card">
                                            <div className="d-flex align-self-center">
                                                <div className={`widget-icon ${data.iconClass}`}>
                                                    {data.svg1}
                                                </div>
                                                <div className="flex-grow-1">
                                                    <H6>{data.title}</H6>
                                                    <H5> {data.title === 'Delivered Order' && '$'}
                                                        <span className="counter"><CountUp end={data.count} duration={5} className="m-0" /></span>
                                                        <span className={`font-roboto ${data.fontClass} f-w-700`}>
                                                            <i className={`icofont ${data.icon}`}></i> {data.percent}</span></H5>
                                                    <div className="icon-bg">
                                                        {data.svg2}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </Col>
                                )
                            })}
                        </Row>
                    </CardBody>
                </Card>
            </Col>
        </Fragment>
    );
};

export default ComplaintDetails;